import * as React from 'react';

import Activity16 from './Activity16';

export const activity16 = () => <Activity16 />;

export default {
    title: 'Icon|Fill|Activity16',
    component: Activity16,
    parameters: {
        notes: "`import Activity16 from 'box-ui-elements/es/icon/fill/Activity16';`",
    },
};
